<ng-container *ngIf="dialogComponentVisible">
    <app-dialog 
        [title]="dialogTitle" [disabled]="dialogAceptarDisabled" [disabledCancel]="!dialogAceptarDisabled" [template]="solicitudDocumentacionEdition" 
        [hasInnerMenu]="true"
        (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #solicitudDocumentacionEdition>
        <app-solicitud-documentacion-edition
            [mode]="mode"
            [readonly]="addingNotAllowed || updatingNotAllowed"
            [doc]="docSelectedToEdit"
            [idSolicitudCam]="solicitudCam?.Id"
            [tiposDocumentacion]="campaniaEspecifica?.Documentacion"
            (saved)="onDocumentacionSaved($event)"
            (fileUpload)="onFileUpload($event)"
            (filePurged)="onFilePurged($event)"
        ></app-solicitud-documentacion-edition>
    </ng-template>
</ng-container>

<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="!addingNotAllowed" [disabled]="!campaniaEspecifica?.AdjuntarDocumentacion" type="button" class="btn btn-outline-success" (click)="onClickAddDoc()" title="Nueva documentación">
            <i class="fa fa-file-o"></i> Nueva Documentación</button>

        <button *ngIf="!visibilitySpinnerEliminando && !readonly" [disabled]="deletingNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickDeleteDocs()" title="Eliminar documentación seleccionada">
            <i class="fa fa-remove"></i> Eliminar documentación seleccionada</button>
        <button *ngIf="visibilitySpinnerEliminando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Eliminando</button>

        <div *ngIf="solicitudCam && !esPeriodoVigente && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no vigente</label>
        </div>
        <div *ngIf="solicitudCam && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info warning">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Solicitud fuera de plazo de Presentación</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-list">
    <ng-container *ngIf="campaniaEspecifica && documentosSolicitudCam && campaniaEspecifica?.AdjuntarDocumentacion">
        <div *ngIf="documentosObligatoriosSinAdjuntar > 0" class="nota-info warning mb-1">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Falta por adjuntar {{ getDocumentosObligatoriosSinAdjuntar() }} documento(s) obligatorio(s).</label>
        </div>
    </ng-container>
        
    <app-solicitud-documentacion-header *ngIf="formGroup"
        [prefixFormControlNameTipoDoc]="prefixFormControlNameTipoDoc" [solicitudCam]="solicitudCam"
        [campaniaEspecifica]="campaniaEspecifica" [formGroup]="formGroup" [disabled]="addingNotAllowed"
    ></app-solicitud-documentacion-header>

    <app-solicitud-documentacion-list *ngIf="formGroup" 
        [documentosSolicitudCam]="documentosSolicitudCam" [disabled]="addingNotAllowed || updatingNotAllowed"
        (removeDoc)="onRemoveDoc($event)" (undoRemoveDoc)="onUndoRemoveDoc($event)" (editDoc)="onEditDoc($event)" (viewDoc)="onViewDoc($event)"
    ></app-solicitud-documentacion-list>
</div>
